import { Helmet } from 'react-helmet'
import './HomePage.scss'
import ListCardComponent from './components/ListCardComponent/ListCardComponent'
import { APP_NAME } from '../../utils/Constans'

const HomePage = () => {

  return (
    <>
      <div className='HomePage containerPage'>
        <div className='row my-5'>
          <Helmet>
            <title>{APP_NAME} | Home</title>
          </Helmet>
          <ListCardComponent></ListCardComponent>
        </div>
      </div>
    </>

    
  )
}

HomePage.propTypes = {}

HomePage.propTypes = {}

export default HomePage
